export default __webpack_public_path__ + "static/media/sd-edit-black-icon.bfa734d3.png";